"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _DefaultHeader = _interopRequireDefault(require("../default/DefaultHeader"));
var _Settings = require("./Settings");
var _helpers = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Component = function Component(props) {
  var showHeader = props.showHeader,
    showFooter = props.showFooter,
    footer = props.footer,
    isShowingLayoutBgColor = props.isShowingLayoutBgColor;
  var header = props.header || /*#__PURE__*/_react["default"].createElement(_DefaultHeader["default"], null);
  var settings = _objectSpread(_objectSpread({}, _Settings.initialSettings), props.settings);
  var bgStyles = (0, _helpers.getBgStyles)(settings, isShowingLayoutBgColor);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].componentWrapper
  }, showHeader && /*#__PURE__*/_react["default"].createElement("div", null, header), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].body,
    style: bgStyles,
    "data-cccisd-survey-area": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, props.children)), showFooter && footer && /*#__PURE__*/_react["default"].createElement("div", null, footer));
};
Component.propTypes = {
  header: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  showHeader: _propTypes["default"].bool,
  showFooter: _propTypes["default"].bool,
  settings: _propTypes["default"].object,
  children: _propTypes["default"].node,
  isShowingLayoutBgColor: _propTypes["default"].bool
};
var _default = Component;
exports["default"] = _default;